import type { CsvTerrificField } from '@entities/platform-entities/integration/csv-terrific-field.type';

export const CSV_REQUIRED_TERRIFIC_FIELDS: readonly CsvTerrificField[] = [
  'title',
  'description',
  'price',
  'salePrice',
  'externalId',
  'externalUrl',
  'imageUrl',
] as const;
